var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMerchant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CABDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 20.0839C20.1692 20.2244 19.3734 20.5389 18.6666 21.0112C17.6799 21.6705 16.9109 22.6075 16.4567 23.7039C16.0026 24.8003 15.8838 26.0067 16.1153 27.1705C16.3468 28.3344 16.9182 29.4035 17.7574 30.2426C18.5965 31.0818 19.6656 31.6532 20.8295 31.8847C21.9933 32.1162 23.1997 31.9974 24.2961 31.5433C25.3925 31.0892 26.3295 30.3201 26.9888 29.3334C27.4611 28.6266 27.7757 27.8308 27.9161 27H22C21.7348 27 21.4804 26.8946 21.2929 26.7071C21.1054 26.5196 21 26.2652 21 26V20.0839ZM17.5554 19.3482C18.871 18.4692 20.4178 18 22 18C22.5523 18 23 18.4477 23 19V25H29C29.5523 25 30 25.4477 30 26C30 27.5823 29.5308 29.129 28.6518 30.4446C27.7727 31.7602 26.5233 32.7855 25.0615 33.391C23.5997 33.9965 21.9911 34.155 20.4393 33.8463C18.8874 33.5376 17.462 32.7757 16.3431 31.6569C15.2243 30.538 14.4624 29.1126 14.1537 27.5607C13.845 26.0089 14.0035 24.4003 14.609 22.9385C15.2145 21.4767 16.2398 20.2273 17.5554 19.3482Z",
    fill: "#1A1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2929 14.2929C25.4804 14.1054 25.7348 14 26 14C28.1217 14 30.1566 14.8429 31.6569 16.3431C33.1571 17.8434 34 19.8783 34 22C34 22.5523 33.5523 23 33 23L26 23C25.7348 23 25.4804 22.8946 25.2929 22.7071C25.1054 22.5196 25 22.2652 25 22V15C25 14.7348 25.1054 14.4804 25.2929 14.2929ZM27 16.0839V21L31.9161 21C31.7098 19.7797 31.1293 18.644 30.2426 17.7574C29.3559 16.8707 28.2203 16.2902 27 16.0839Z",
    fill: "#1A1D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchant);
export default __webpack_public_path__ + "static/media/Merchant.fcc82ca171f4e884b72e38d8e33a8a4c.svg";
export { ForwardRef as ReactComponent };